import React from 'react';
import { SegmentManager } from '@rasahq/react-tabula/vendor/segment';
import { Link } from 'gatsby';

import '@rasahq/react-tabula/vendor/segment/consent-manager.scss';

import rasaSquare from 'src/assets/vector/rasa-square.svg';

export default function PageFooter() {
  return (
    <nav
      className="footer-nav frame wrap-last chain-s py-s f-sans-xs fw-500 ui-fg"
      style={{ overflow: 'hidden' }}
    >
      <a href="https://rasa.com/">
        <span className="v-hide">Rasa Developer Summit 2021</span>
        <div style={{ width: '40px' }}>
          <div
            style={{
              paddingBottom: `${(189 / 156) * 100}%`,
              position: 'relative',
              height: '30px',
            }}
          >
            <img
              src={rasaSquare}
              alt=""
              style={{ position: 'absolute', top: 0, left: 0, width: '100%' }}
            />
          </div>
        </div>
      </a>
      <a className="link-plain ml-auto" href="https://rasa.com/about/">
        About Rasa
      </a>
      <a
        className="link-plain"
        href="https://rasa.com/community/code-of-conduct/"
      >
        Code of Conduct
      </a>
      <a className="link-plain" href="https://rasa.com/privacy-policy/">
        Privacy Policy
      </a>
      <a className="link-plain" href="https://rasa.com/imprint/">
        Imprint
      </a>
      <SegmentManager className="link-plain" linkComponent={Link}>
        Analytics Preferences
      </SegmentManager>
    </nav>
  );
}
